"use strict";

exports.__esModule = true;
exports.default = void 0;
var _addClasses = _interopRequireDefault(require("./addClasses"));
var _removeClasses = _interopRequireDefault(require("./removeClasses"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var _default = {
  addClasses: _addClasses.default,
  removeClasses: _removeClasses.default
};
exports.default = _default;